import { html, View } from 'rune-ts';
import klass from './ReviewView.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { font } from '@services/MarppleShop/shared/typography';

const star_icon_html = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 13 13"
  fill="none"
>
  <path
    d="M5.52933 1.61379C5.72433 1.22379 6.28224 1.22379 6.47724 1.61379L7.74474 4.17587C7.82058 4.33296 7.97224 4.44129 8.14016 4.46296L10.9677 4.87462C11.401 4.93962 11.5743 5.47046 11.2602 5.77379L9.21266 7.76712C9.08808 7.88629 9.03391 8.06504 9.06099 8.23296L9.54308 11.0496C9.61891 11.483 9.16391 11.808 8.77933 11.6075L6.24974 10.275C6.09808 10.1938 5.91391 10.1938 5.75683 10.275L3.22724 11.6075C2.84266 11.8134 2.38766 11.483 2.46349 11.0496L2.94558 8.23296C2.97266 8.05962 2.91849 7.88629 2.79391 7.76712L0.746411 5.77379C0.432245 5.47046 0.605578 4.93421 1.03891 4.87462L3.86641 4.46296C4.03974 4.43587 4.18599 4.32754 4.26183 4.17587L5.52933 1.61379Z"
    fill="#FFB121"
  />
</svg>`;

export type TProps =
  | {
      theme: 'Light';
      size: 'Medium';
      review_count: number;
      review_score: number;
    }
  | {
      theme: 'Dark';
      size: 'Medium';
      review_count: number;
      review_score: number;
    }
  | {
      theme: 'Dark';
      size: 'Small';
      review_count: number;
      review_score: number;
    }
  | {
      theme: 'Light';
      size: 'Small';
      review_count: number;
      review_score: number;
    };

/**
 * https://www.figma.com/design/J3pxvmlv167DXuLToyL3Mg/%EC%83%81%ED%92%88-%EC%B9%B4%EB%93%9C-UI?node-id=368-190081&m=dev
 */
export class ReviewView extends View<TProps> {
  protected override template({ size, theme, review_count, review_score }: TProps) {
    return html`
      <span
        class="${classes(klass.review, {
          [klass.size_medium]: size === 'Medium',
          [klass.size_small]: size === 'Small',
        })}"
      >
        <span
          class="${classes(klass.review_score, {
            [klass.size_medium]: size === 'Medium',
            [klass.size_small]: size === 'Small',
          })}"
        >
          <span
            class="${classes(klass.icon, {
              [klass.size_medium]: size === 'Medium',
              [klass.size_small]: size === 'Small',
            })}"
            >${star_icon_html}</span
          >

          <span
            class="${classes(
              klass.review_score_text,
              { [klass.theme_light]: theme === 'Light', [klass.theme_dark]: theme === 'Dark' },
              {
                [font('12_medium')]: size === 'Medium',
                [font('10_medium')]: size === 'Small',
              },
            )}"
            >${review_score}</span
          >
        </span>

        <span
          class="${classes(klass.review_count, {
            [klass.size_medium]: size === 'Medium',
            [klass.size_small]: size === 'Small',
          })}"
        >
          <span
            class="${classes(
              klass.review_count_text,
              { [klass.theme_light]: theme === 'Light', [klass.theme_dark]: theme === 'Dark' },
              {
                [font('12_medium')]: size === 'Medium',
                [font('10_medium')]: size === 'Small',
              },
            )}"
          >
            ${ET('card_product::review::review')}
          </span>

          <span
            class="${classes(
              klass.review_count_text,
              { [klass.theme_light]: theme === 'Light', [klass.theme_dark]: theme === 'Dark' },
              {
                [font('12_medium')]: size === 'Medium',
                [font('10_medium')]: size === 'Small',
              },
            )}"
            >${review_count}</span
          >
        </span>
      </span>
    `;
  }
}
